import React, {useState} from "react";
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Switch,
    useToast,
} from "@chakra-ui/react";
import {addRoster} from "./services";

const AddRosterModal = ({addRosterModal, onClose, fetchRosterList, selectedSchool}) => {
    const toast = useToast();

    const [rosterName, setRosterName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isEnabled, setIsEnabled] = useState(false);
    const [speakerAddress, setSpeakerAddress] = useState("");

    const handleSubmit = async () => {
        let request = {
            schoolId: Number(selectedSchool),
            name: rosterName,
            startDate: Date.parse(startDate),
            endDate: Date.parse(endDate),
            isEnabled: isEnabled ? "Y" : "N",
            speakerAddress: speakerAddress,
        };

        try {
            const response = await addRoster(request);
            if (response.status === 201) {
                toast({
                    title: "सफलता!",
                    description: "नयाँ रोस्टर सफलतापूर्वक थपियो।",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                fetchRosterList();
                resetForm();
                onClose();
            }
        } catch (e) {
            console.log(e);
            toast({
                title: "असफलता!",
                description: "रोस्टर थप्न असफल भयो। कृपया पुनः प्रयास गर्नुहोस्।",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    const resetForm = () => {
        setRosterName("");
        setStartDate("");
        setEndDate("");
        setIsEnabled(false);
        setSpeakerAddress("");
    };

    return (
        <>
            <Modal isOpen={addRosterModal} onClose={onClose}>
                <ModalOverlay/>
                <ModalContent>
                    <ModalHeader>नयाँ रोस्टर थप्नुहोस्</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <FormControl mb="4">
                            <FormLabel>रोस्टर नाम</FormLabel>
                            <Input
                                placeholder="रोस्टर नाम प्रविष्ट गर्नुहोस्"
                                value={rosterName}
                                onChange={(e) => setRosterName(e.target.value)}
                            />
                        </FormControl>
                        <FormControl mb="4">
                            <FormLabel>सुरु मिति</FormLabel>
                            <Input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </FormControl>
                        <FormControl mb="4">
                            <FormLabel>अन्त्य मिति</FormLabel>
                            <Input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </FormControl>
                        <FormControl display="flex" alignItems="center" mb="4">
                            <FormLabel mb="0">सक्रिय छ?</FormLabel>
                            <Switch
                                isChecked={isEnabled}
                                onChange={(e) => setIsEnabled(e.target.checked)}
                            />
                        </FormControl>
                        <FormControl mb="4">
                            <FormLabel>स्पीकर ठेगाना</FormLabel>
                            <Input
                                placeholder="स्पीकर ठेगाना प्रविष्ट गर्नुहोस्"
                                value={speakerAddress}
                                onChange={(e) => setSpeakerAddress(e.target.value)}
                            />
                        </FormControl>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="blue" mr="3" onClick={() => handleSubmit()}>
                            पेश गर्नुहोस्
                        </Button>
                        <Button onClick={onClose}>रद्द गर्नुहोस्</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default AddRosterModal;